
import manvarLogo from '../../../../assets/img/manvar-logo.png'
import jsPDF from "jspdf";
import 'jspdf-autotable';
import { justifyTextBox } from 'common';

export const useHelpers = () => {
    const defaultFontSize = 10
    const titleFontSize = 15

    const getCurrentDate = () => {
        const today = new Date()
        const year = today.getFullYear()
        const month = String(today.getMonth() + 1).padStart(2, '0')
        const day = String(today.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
    }

    const getCurrentStartMonth = () => {
        const today = new Date()
        const year = today.getFullYear()
        const month = String(today.getMonth() + 1).padStart(2, '0')
        return `${year}-${month}-01`
    }

    const formatMoney = (value) => {
        const num = typeof value === 'string'
            ? parseFloat(value.replace(/,/g, ''))
            : Number(value);

        if (isNaN(num)) return '0.00';

        return num.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    const money = (v) => formatMoney(v)

    const convertToFloat = (formattedNumber) => {
        if (formattedNumber === null || formattedNumber === undefined) return 0;

        const cleanedValue = String(formattedNumber).replace(/,/g, '');
        const floatValue = parseFloat(cleanedValue);

        return isNaN(floatValue) ? 0 : floatValue;
    };

    const _drawHeaderBankReport = (docPdf, data, posY) => {

        docPdf.setFont("helvetica", "bold");
        docPdf.setFontSize(titleFontSize);
        docPdf.text('REPORTE DE DEPÓSITOS BANCARIOS', 110, posY, { align: 'center' });
        docPdf.setFontSize(defaultFontSize);

        posY += 10;

        docPdf.setFont("helvetica", "bold");
        docPdf.text('INFORMACIÓN GENERAL', 20, posY, { align: 'left' });
        docPdf.line(20, posY + 1, 200, posY + 1);

        posY += 8;

        docPdf.setFont("helvetica", "bold");
        docPdf.text('BANCO: ', 20, posY, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(String(data?.banco || 'TODOS LOS BANCOS'), 45, posY, { align: 'left' });

        posY += 6;

        docPdf.setFont("helvetica", "bold");
        docPdf.text('RANGO: ', 20, posY, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(
            `${String(data?.fecha_inicio || '')} a ${String(data?.fecha_fin || '')}`,
            45,
            posY,
            { align: 'left' }
        );

        posY += 10;

        const totals = data?.totals || {};
        const totalQ = Number(totals?.total_quetzales ?? data?.summary?.depositos?.quetzales ?? 0);
        const totalU = Number(totals?.total_dolares ?? data?.summary?.depositos?.dolares ?? 0);
        const count = Number(totals?.total_transacciones ?? data?.summary?.depositos?.cantidad ?? 0);

        docPdf.setFont("helvetica", "bold");
        docPdf.text("TOTAL DEPÓSITOS:", 20, posY, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(`Q ${formatMoney(totalQ)}`, 70, posY, { align: 'left' });
        docPdf.text(`$ ${formatMoney(totalU)}`, 120, posY, { align: 'left' });

        posY += 6;

        docPdf.setFont("helvetica", "bold");
        docPdf.text("TRANSACCIONES:", 20, posY, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(String(count), 70, posY, { align: 'left' });

        posY += 6;
    };

    const _drawBodyBankReport = (docPdf, data, posY) => {
        const left = 15;
        const right = 200;

        docPdf.setFont("helvetica", "bold");
        docPdf.text(
            `DEPÓSITOS REGISTRADOS ENTRE ${data?.fecha_inicio || ''} y ${data?.fecha_fin || ''}`,
            left,
            posY
        );
        docPdf.line(left, posY + 2, right, posY + 2);

        posY += 12;

        const col = {
            banco: 15,
            fecha: 52,
            origen: 75,
            moneda: 115,
            tc: 135,
            quetzales: 160,
            dolares: 180,
            boleta: 200,
        };

        docPdf.setFont("helvetica", "bold");
        docPdf.text("BANCO", col.banco, posY);
        docPdf.text("FECHA", col.fecha, posY);
        docPdf.text("ORIGEN", col.origen, posY);
        docPdf.text("MON", col.moneda, posY);
        docPdf.text("T/C", col.tc, posY, { align: "right" });
        docPdf.text("Q", col.quetzales, posY, { align: "right" });
        docPdf.text("$", col.dolares, posY, { align: "right" });
        docPdf.text("BOLETA", col.boleta, posY, { align: "right" });

        docPdf.line(left, posY + 2, right, posY + 2);
        posY += 8;

        const deposits = Array.isArray(data?.deposits) ? data.deposits : [];
        docPdf.setFont("helvetica", "normal");

        const safeText = (v) => String(v ?? "").trim();

        const monedaShort = (m) => {
            const x = safeText(m).toUpperCase();
            if (x.includes("QUETZ")) return "GTQ";
            if (x.includes("DOL") || x.includes("USD")) return "USD";
            return x.slice(0, 6);
        };

        const wrap = (txt, maxWidth) => {
            const t = safeText(txt);
            if (!t) return [""];
            return docPdf.splitTextToSize(t, maxWidth);
        };

        const bancoWidth = 35;
        const origenWidth = (col.moneda - col.origen) - 2;

        deposits.forEach((r) => {
            if (posY > 255) {
                docPdf.addPage();
                posY = 20;
            }

            const banco = safeText(r?.banco || 'SIN BANCO');
            const fecha = safeText(r?.fecha);
            const origen = safeText(r?.origen);
            const mon = monedaShort(r?.moneda);
            const tc = r?.tipo_cambio ? Number(r.tipo_cambio).toFixed(2) : '-';
            const q = Number(r?.quetzales ?? 0);
            const usd = Number(r?.dolares ?? 0);
            const boleta = safeText(r?.boleta_numero);

            const bancoLines = wrap(banco, bancoWidth);
            let origenLines = wrap(origen, origenWidth);

            if (origenLines.length > 2) {
                origenLines = origenLines.slice(0, 2);
                origenLines[1] = origenLines[1].replace(/\s+$/, '') + '...';
            }

            const maxLines = Math.max(bancoLines.length, origenLines.length, 1);
            const lineHeight = 5;
            const rowHeight = maxLines * lineHeight;

            docPdf.text(bancoLines, col.banco, posY);
            docPdf.text(fecha, col.fecha, posY);
            docPdf.text(origenLines, col.origen, posY);

            docPdf.text(mon, col.moneda, posY);
            docPdf.text(tc, col.tc, posY, { align: "right" });

            docPdf.text(`Q ${formatMoney(q)}`, col.quetzales, posY, { align: "right" });
            docPdf.text(`$ ${formatMoney(usd)}`, col.dolares, posY, { align: "right" });
            docPdf.text(boleta, col.boleta, posY, { align: "right" });

            posY += rowHeight;
        });
    };

    const drawBankDepositsReport = (data) => {
        const doc = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'letter',
        });

        _drawHeaderBankReport(doc, data, 15);
        _drawBodyBankReport(doc, data, 70);

        const banco = String(data?.banco || 'BANCOS');
    

        doc.save(`REPORTE DEPOSITOS ${banco} ${data?.fecha_inicio || ''} A ${data?.fecha_fin || ''}.pdf`);
    };

    const _toDMY = (ymd) => {
        if (!ymd || typeof ymd !== 'string') return ''
        const [y, m, d] = ymd.split('-')
        return (y && m && d) ? `${d}-${m}-${y}` : ymd
    }

    const _drawHeaderMovementsReport = (docPdf, data, posY) => {
        docPdf.setFont("helvetica", "bold");
        docPdf.setFontSize(titleFontSize);
        docPdf.text('REPORTE DE MOVIMIENTOS DE BANCO', 110, posY, { align: 'center' });
        docPdf.setFontSize(defaultFontSize);

        posY += 10;

        docPdf.setFont("helvetica", "bold");
        docPdf.text('INFORMACIÓN GENERAL', 20, posY, { align: 'left' });
        docPdf.line(20, posY + 1, 200, posY + 1);

        posY += 8;

        docPdf.setFont("helvetica", "bold");
        docPdf.text('BANCO: ', 20, posY, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(String(data.banco || 'TODOS LOS BANCOS'), 45, posY, { align: 'left' });

        const summary = data.summary || {}
        const rows = [
            ['SALDO HISTORICO: ', summary?.fullBalance?.historico_quetzales, summary?.fullBalance?.historico_dolares],
            ['SALDO TOTAL: ', summary?.fullBalance?.quetzales, summary?.fullBalance?.dolares],
            ['TOTAL INGRESOS:', summary?.ingresos?.quetzales, summary?.ingresos?.dolares],
            ['TOTAL EGRESOS:', summary?.egresos?.quetzales, summary?.egresos?.dolares],
            ['BALANCE (I - E):', summary?.balance?.quetzales, summary?.balance?.dolares],
        ]

        rows.forEach(([label, q, usd]) => {
            posY += 6;
            docPdf.setFont("helvetica", "bold");
            docPdf.text(label, 20, posY, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(`Q ${formatMoney(Number(q || 0))}`, 70, posY, { align: 'left' });
            docPdf.text(`$ ${formatMoney(Number(usd || 0))}`, 120, posY, { align: 'left' });
        })
    }

    const _drawBodyMovementsReport = (docPdf, data, posY) => {
        docPdf.setFont("helvetica", "bold");
        docPdf.text(`MOVIMIENTOS REGISTRADOS ENTRE ${_toDMY(data.fecha_inicio)} y ${_toDMY(data.fecha_fin)}`, 20, posY, { align: 'left' });
        docPdf.line(20, posY + 1, 200, posY + 1);

        posY += 10;

        const tipo = data?.movimiento_tipo ?? 'ALL';
        const movements = Array.isArray(data.movements) ? data.movements : [];
        const movementsToPrint = (tipo === 'ALL') ? movements : movements.filter(m => m.movimiento_tipo === tipo);

        docPdf.setFont("helvetica", "bold");
        docPdf.text("FECHA", 20, posY, { align: 'left' });
        docPdf.text("TIPO", 52, posY, { align: 'left' });
        docPdf.text("MONEDA", 82, posY, { align: 'left' });
        docPdf.text("CAMBIO", 110, posY, { align: 'left' });
        docPdf.text("QUETZALES", 132, posY, { align: 'left' });
        docPdf.text("DOLARES", 162, posY, { align: 'left' });
        docPdf.line(20, posY + 1, 200, posY + 1);

        posY += 8;

        for (let i = 0; i < movementsToPrint.length; i++) {
            const mov = movementsToPrint[i];
            if (posY > 260) {
                docPdf.addPage();
                posY = 20;
            }

            docPdf.setFont("helvetica", "normal");
            docPdf.text(String(mov.movimiento_fecha || ''), 20, posY, { align: 'left' });
            docPdf.text(String(mov.movimiento_tipo || ''), 52, posY, { align: 'left' });
            docPdf.text(String(mov.movimiento_moneda || ''), 82, posY, { align: 'left' });
            docPdf.text(`Q ${formatMoney(Number(mov.movimiento_tipo_cambio || 0))}`, 110, posY, { align: 'left' });
            docPdf.text(`Q ${formatMoney(Number(mov.movimiento_quetzales || 0))}`, 132, posY, { align: 'left' });
            docPdf.text(`$ ${formatMoney(Number(mov.movimiento_dolares || 0))}`, 162, posY, { align: 'left' });

            // Con "Todos los bancos" se antepone el banco a las observaciones
            const obs = String(mov.movimiento_observaciones || '');
            const detail = data.todosLosBancos ? [mov.banco, obs].filter(Boolean).join(' - ') : obs;
            const obsLines = docPdf.splitTextToSize(detail, 120);
            docPdf.text(obsLines, 52, posY + 5);
            const endY = posY + 5 + obsLines.length * 4;
            docPdf.setDrawColor(0);
            docPdf.setLineWidth(0.2);
            docPdf.line(20, endY + 2, 200, endY + 2);
            posY = endY + 6;
        }
    }

    const drawBankMovementsReport = (data) => {
        const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'letter' });

        _drawHeaderMovementsReport(doc, data, 15);
        _drawBodyMovementsReport(doc, data, 80);

        const tipo = data?.movimiento_tipo ?? 'ALL';
        const tipoLabel = tipo === 'ALL' ? 'MOVIMIENTOS' : tipo;

        const docName = `REPORTE ${data.banco || 'BANCOS'} ${tipoLabel} ${_toDMY(data.fecha_inicio)} A ${_toDMY(data.fecha_fin)}.pdf`
        const docBase64 = doc.output("datauristring").replace(/;filename=[^;]+/, '')

        return { docName, docBase64 }
    }

    // ---- Comprobante de movimiento (mismo formato que el recibo de pago de /gestiones-creditos-pagos)
    const _box = (docPdf, label, value, x, y, labelW, totalW) => {
        docPdf.setFillColor(230, 230, 230);
        docPdf.rect(x, y, labelW, 5, 'F');
        docPdf.rect(x, y, totalW, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text(label, x + 3, y + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(String(value ?? '---'), x + labelW + 2, y + 4, { align: 'left' });
    }

    const _drawHeaderBankReceipt = (docPdf, data, posY) => {
        // Marco y logo
        docPdf.rect(10, 10, 260, 195);
        docPdf.addImage(manvarLogo, 'PNG', 20, posY - 15, 50, 30);

        // Membrete principal
        docPdf.setFont("helvetica", "bold");
        docPdf.setFontSize(25);
        docPdf.text('GRUPO MANVAR S.A.', 140, posY, { align: 'center' });
        docPdf.setFontSize(defaultFontSize);

        docPdf.setFont("helvetica", "normal");
        docPdf.text('KILÓMETRO 59.5 CARRETERA A TAXISCO, ESCUINTLA, ESCUINTLA', 140, posY + 5, { align: 'center' });
        docPdf.text('TELEFONO: 2458-1568 EXTENSION 1', 140, posY + 10, { align: 'center' });

        // Identificadores
        docPdf.setFont("helvetica", "bold");
        docPdf.text('MOVIMIENTO BANCARIO', 215, posY);
        docPdf.text(`RECIBO NO. ${data.idmovimiento}`, 215, posY + 5);

        posY += 20

        // Fecha y hora de impresion
        const now = new Date()
        const hhmm = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`
        _box(docPdf, 'FECHA Y HORA DE IMPRESION', `${getCurrentDate()} ${hhmm}`, 20, posY, 62, 160)
        _box(docPdf, 'ESTADO', 'APROBADO', 180, posY, 35, 80)

        posY += 10

        // Operado por / Por
        const isUSD = data.movimiento_moneda === 'DOLAR'
        _box(docPdf, 'OPERADO POR', data.usuario_creo || '---', 20, posY, 35, 160)
        _box(docPdf, isUSD ? 'POR $' : 'POR Q', money(isUSD ? data.movimiento_dolares : data.movimiento_quetzales), 180, posY, 35, 80)

        posY += 5

        // Fecha del movimiento
        _box(docPdf, 'F. MOVIMIENTO', data.movimiento_fecha, 180, posY, 35, 80)
    }

    const _drawInfoBankReceipt = (docPdf, data, posY) => {
        _box(docPdf, 'TIPO', data.movimiento_tipo, 20, posY, 23, 47)
        _box(docPdf, 'MONTO', money(data.movimiento_monto), 67, posY, 23, 47)
        posY += 5
        _box(docPdf, 'MONEDA', data.movimiento_moneda, 20, posY, 23, 47)
        _box(docPdf, 'CAMBIO', money(data.movimiento_tipo_cambio), 67, posY, 23, 47)
        posY += 5
        _box(docPdf, 'TOTAL Q.', money(data.movimiento_quetzales), 20, posY, 23, 47)
        _box(docPdf, 'TOTAL $.', money(data.movimiento_dolares), 67, posY, 23, 47)

        posY += 15

        _box(docPdf, 'BOLETA', data.boleta_numero || '---', 20, posY, 23, 47)
        _box(docPdf, 'ACH', data.aprobacion_referencia_ach || '---', 67, posY, 23, 47)

        posY += 10

        _box(docPdf, 'BANCO', data.banco || '---', 20, posY, 23, 154)
    }

    const _drawObservationsBankReceipt = (docPdf, data, posY) => {
        docPdf.rect(180, posY, 80, 70);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('OBSERVACIONES', 183, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        justifyTextBox(docPdf, data.movimiento_observaciones || '', 181, posY + 9, 80, {
            fontSize: defaultFontSize,
            fontName: 'helvetica',
            lineSpacing: 5
        })
    }

    const _drawFooterBankReceipt = (docPdf, posY) => {
        docPdf.line(20, posY, 90, posY);
        docPdf.setFont("helvetica", "normal");
        docPdf.text('FIRMA AUTORIZADA', 40, posY + 7, { align: 'left' });
        docPdf.text('SELLO', 125, posY + 4, { align: 'left' });

        posY += 20
        const text = '*NOTA:* Por cheque rechazado se cobrará en concepto de gastos administrativos: Q150.00 cheques en Quetzales y $20.00 cheques en dólares, quedando anulado este recibo de inmediato. INTERESES Y MORA: Se cobrará 10% sobre la cuota a vigente a cancelar y un monto de Q10.00 diarios en concepto de mora, hasta hacer efectivo el pago correspondiente, este monto podrá variar conforme al contrato vigente o conforme a políticas internas sin previo aviso. Plazo Extemporáneo: Se cobrará Q1,000.00 por me adicional después de vencido el plazo contractual o estipulado por cada negocio.'
        justifyTextBox(docPdf, text, 20, posY, 240, {
            fontSize: defaultFontSize,
            fontName: 'helvetica',
            lineSpacing: 5
        })
    }

    const drawBankMovementReceipt = (data) => {
        const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'letter' });

        _drawHeaderBankReceipt(doc, data, 30)
        _drawInfoBankReceipt(doc, data, 85)
        _drawObservationsBankReceipt(doc, data, 85)
        _drawFooterBankReceipt(doc, 155)

        doc.save(`COMPROBANTE BANCO ${data.idmovimiento}.pdf`)
    }

    return Object.freeze({
        getCurrentDate,
        getCurrentStartMonth,
        formatMoney,
        drawBankDepositsReport,
        drawBankMovementsReport,
        drawBankMovementReceipt,
        convertToFloat,
    })
}
